module.exports = __webpack_public_path__ + "static/media/art1.4db9c97d.jpg";